import compress from '@/utilities/compress';
import store from '@/store/store';

let cache;

export async function init(cacheName) {
  if (!window.caches) {
    return;
  }

  cache = await caches.open(cacheName);
}

export async function add(name, image) {
  const file = await compress(image);
  const type = name.split('.').pop();

  const response = new Response(file, {
    status: 200,
    statusText: 'OK',
    headers: { 'Content-Type': `image/${type}` },
  });

  const baseURL = store.state.axiosVariables.baseUrl;

  const url = `${baseURL}/files/download/${name}`;

  await cache.put(url, response);

  return url;
}

export function match(url) {
  return cache.match(url).then(response => {
    if (response && response.ok) {
      return response.blob();
    }

    return Promise.reject();
  });
}

export function find(file) {
  return match(file).then(() => `${baseURL}/files/download/${file}`);
}

export function remove(url) {
  return cache.delete(url);
}

export function push(file) {
  return add(file.name, file);
}

export function all() {
  return cache.keys();
}

export default {
  all,
  add,
  push,
  find,
  init,
  match,
  remove,
};
